import { ETaskSubStatus } from "@/enums/taskEnums.js";

/**
 * Gets the translation key for a task substatus
 * @param {number} subStatus - The substatus code
 * @param {Function} $t - Vue i18n translation function
 * @returns {string} Translated status label
 */
export function getTaskStatusLabel(subStatus, $t) {
   if (!subStatus || !$t) return "-";

   const statusKey = ETaskSubStatus[subStatus];
   if (!statusKey) return "-";

   // Convert enum key to i18n key format
   // Example: WAITING_ON_OPERATOR -> taskLogs_statusWaitingOnOperator
   const i18nKey =
      "taskLogs_status" +
      statusKey.charAt(0) +
      statusKey
         .slice(1)
         .toLowerCase()
         .replace(/_./g, (match) => match.charAt(1).toUpperCase());

   return $t(i18nKey);
}
